import { LazyImport, LazyModule } from 'owa-bundling';
import { AnnotationHandler } from 'owa-editor-augloop-plugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TextPredictionHandler" */ './lazyIndex')
);

export let lazyGetHandler = new LazyImport(lazyModule, m => m.getHandler);

export async function getAnnotationHandlerAsync(): Promise<AnnotationHandler> {
    const getHandler = await lazyGetHandler.import();
    return getHandler();
}
